var _rect, _rect2, _g, _defs, _rect3, _line, _g2, _defs2, _g3, _defs3, _g4, _defs4, _g5, _defs5, _g6, _defs6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricsPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-generator-version": 10,
    height: 267,
    viewBox: "0 0 300 267",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f6f6f7",
    height: 267,
    width: 300,
    x: 0,
    y: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 120,
    rx: 2,
    ry: 2,
    width: 68,
    x: 5,
    xmlns: "http://www.w3.org/2000/svg",
    y: 5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    "data-aspect-ratio": "thin",
    "data-slug": "pie",
    "data-variant": "b",
    height: 120,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 60 102",
    width: 68,
    x: 5,
    xmlns: "http://www.w3.org/2000/svg",
    y: 5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ref3571",
    transform: "translate(17070 12096)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "evenodd",
    id: "ref3568"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17070 -12096L -17010 -12096L -17010 -11994L -17070 -11994L -17070 -12096Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ref3568)",
    id: "ref3570"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17070 -12096L -17010 -12096L -17010 -11994L -17070 -11994L -17070 -12096Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ref3569"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    transform: "translate(-17070 -12096)",
    xlinkHref: "#ref3572"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "translate(-17062 -12067)",
    xlinkHref: "#ref3573"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9fdee0",
    transform: "translate(-17054.1 -12045)",
    xlinkHref: "#ref3574"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "translate(-17040 -12052.6)",
    xlinkHref: "#ref3575"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "translate(-17040 -12067)",
    xlinkHref: "#ref3576"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 2C 0 0.895431 0.895431 0 2 0L 58 0C 59.1046 0 60 0.895431 60 2L 60 100C 60 101.105 59.1046 102 58 102L 2 102C 0.895431 102 0 101.105 0 100L 0 2Z",
    id: "ref3572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.9613 21.9633L 7.8512 38.8019C -1.45102 31.0101 -2.65299 17.1523 5.1337 7.84405C 9.47125 2.66698 15.2198 0 21.9613 0L 21.9613 21.9633Z",
    id: "ref3573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.1101 0L 27.3318 17.5707C 19.0748 23.7936 7.89121 23.4798 0 16.8386L 14.1101 0Z",
    id: "ref3574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 7.53028L 20.6426 1.99484e-07C 24.0394 9.30827 21.1129 19.1395 13.2217 25.0487L 0 7.53028Z",
    id: "ref3575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 21.9633L 0 0C 9.40674 0 17.4025 5.59542 20.6426 14.4853L 0 21.9633Z",
    id: "ref3576"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 45,
    rx: 2,
    ry: 2,
    width: 105,
    x: 78,
    xmlns: "http://www.w3.org/2000/svg",
    y: 5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    height: 45,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 233 50",
    width: 105,
    x: 78,
    xmlns: "http://www.w3.org/2000/svg",
    y: 5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "color1",
    stroke: "#A4A6A9",
    strokeLinecap: "round",
    strokeWidth: 16,
    x1: 76,
    x2: 156,
    y1: 25,
    y2: 25
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    "data-aspect-ratio": "wide",
    "data-slug": "line",
    "data-variant": "e",
    height: 57,
    preserveAspectRatio: "none",
    viewBox: "0 0 272 102",
    width: 105,
    x: 189,
    xmlns: "http://www.w3.org/2000/svg",
    y: 5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ref2714",
    transform: "translate(17914 9134)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "evenodd",
    id: "ref2711"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17914 -9134L -17642 -9134L -17642 -9032L -17914 -9032L -17914 -9134Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ref2711)",
    id: "ref2713"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17914 -9134L -17642 -9134L -17642 -9032L -17914 -9032L -17914 -9134Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ref2712"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    transform: "translate(-17914 -9134)",
    xlinkHref: "#ref2715"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "translate(-17919 -9093)",
    xlinkHref: "#ref2717"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "matrix(-1 -6.33558e-17 2.3672e-16 -1 -17638 -9053)",
    xlinkHref: "#ref2718"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "matrix(1 -5.91089e-17 -1.14255e-16 1 -17919 -9107)",
    xlinkHref: "#ref2718"
  }))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 2C 0 0.895431 0.895431 0 2 0L 270 0C 271.105 0 272 0.895431 272 2L 272 100C 272 101.105 271.105 102 270 102L 2 102C 0.895431 102 0 101.105 0 100L 0 2Z",
    id: "ref2715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 137.097 27.1372L 136.318 28.9793L 137.429 29.4491L 138.363 28.6855L 137.097 27.1372ZM 70.7246 4.43688L 71.23 2.50179L 70.446 2.29704L 69.7406 2.69567L 70.7246 4.43688ZM 203.469 23.1131L 202.326 24.7542L 203.205 25.3662L 204.201 24.9743L 203.469 23.1131ZM 236.655 10.0604L 236.168 8.12062L 236.043 8.15201L 235.923 8.19916L 236.655 10.0604ZM 170.283 0L 171.426 -1.64118L 170.186 -2.50455L 169.017 -1.54826L 170.283 0ZM 103.911 13.1043L 104.69 11.2622L 104.556 11.2058L 104.416 11.1692L 103.911 13.1043ZM 37.5384 23.1905L 36.5545 21.4492L 36.3628 21.5576L 36.1992 21.705L 37.5384 23.1905ZM 204.201 24.9743L 237.387 11.9216L 235.923 8.19916L 202.737 21.2519L 204.201 24.9743ZM 237.143 12.0001L 274.681 2.57175L 273.707 -1.30775L 236.168 8.12062L 237.143 12.0001ZM 169.14 1.64118L 202.326 24.7542L 204.612 21.4719L 171.426 -1.64118L 169.14 1.64118ZM 138.363 28.6855L 171.549 1.54826L 169.017 -1.54826L 135.831 25.589L 138.363 28.6855ZM 70.2192 6.37197L 103.405 15.0394L 104.416 11.1692L 71.23 2.50179L 70.2192 6.37197ZM 103.132 14.9464L 136.318 28.9793L 137.876 25.2951L 104.69 11.2622L 103.132 14.9464ZM 1.33923 58.52L 38.8777 24.6759L 36.1992 21.705L -1.33923 55.5492L 1.33923 58.52ZM 38.5224 24.9317L 71.7085 6.17809L 69.7406 2.69567L 36.5545 21.4492L 38.5224 24.9317Z",
    id: "ref2716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 140.004 19L 140.004 21L 140.441 21L 140.838 20.8175L 140.004 19ZM 72.224 8.02125L 72.7088 6.08087L 72.2691 5.97103L 71.8249 6.06147L 72.224 8.02125ZM 207.783 15.8822L 207.094 17.7597L 207.427 17.8822L 207.783 17.8822L 207.783 15.8822ZM 243.269 15.8822L 243.269 17.8822L 243.672 17.8822L 244.044 17.7256L 243.269 15.8822ZM 173.893 3.43789L 174.583 1.56046L 173.808 1.27612L 173.059 1.62035L 173.893 3.43789ZM 116.173 19L 115.688 20.9404L 115.927 21L 116.173 21L 116.173 19ZM 38.3343 14.9229L 37.6088 16.7867L 38.157 17.0001L 38.7334 16.8827L 38.3343 14.9229ZM 207.783 17.8822L 243.269 17.8822L 243.269 13.8822L 207.783 13.8822L 207.783 17.8822ZM 244.044 17.7256L 281.776 1.84335L 280.224 -1.84335L 242.493 14.0389L 244.044 17.7256ZM 173.204 5.31531L 207.094 17.7597L 208.472 14.0048L 174.583 1.56046L 173.204 5.31531ZM 140.838 20.8175L 174.728 5.25542L 173.059 1.62035L 139.169 17.1825L 140.838 20.8175ZM 71.7393 9.96162L 115.688 20.9404L 116.658 17.0596L 72.7088 6.08087L 71.7393 9.96162ZM 116.173 21L 140.004 21L 140.004 17L 116.173 17L 116.173 21ZM -0.725517 1.86413L 37.6088 16.7867L 39.0598 13.0592L 0.725517 -1.8634L -0.725517 1.86413ZM 38.7334 16.8827L 72.6232 9.98102L 71.8249 6.06147L 37.9352 12.9632L 38.7334 16.8827Z",
    id: "ref2717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 137.097 24.0675L 136.379 25.9342L 136.581 26.012L 136.796 26.0447L 137.097 24.0675ZM 70.7246 13.4396L 69.9739 15.2934L 70.2982 15.4247L 70.6479 15.4382L 70.7246 13.4396ZM 204.187 42.2536L 203.465 44.1186L 204.636 44.5721L 205.553 43.7144L 204.187 42.2536ZM 235 13.4396L 235.645 11.5466L 234.51 11.1595L 233.634 11.9788L 235 13.4396ZM 170.283 29.1235L 171.005 27.2585L 170.801 27.1793L 170.584 27.1463L 170.283 29.1235ZM 113.761 15.0906L 114.479 13.2239L 114.17 13.1048L 113.838 13.092L 113.761 15.0906ZM 37.5384 0L 38.2892 -1.85375L 37.2922 -2.2575L 36.4057 -1.64833L 37.5384 0ZM 205.553 43.7144L 236.366 14.9004L 233.634 11.9788L 202.821 40.7928L 205.553 43.7144ZM 234.355 15.3326L 280.355 31.0165L 281.645 27.2305L 235.645 11.5466L 234.355 15.3326ZM 169.561 30.9885L 203.465 44.1186L 204.909 40.3885L 171.005 27.2585L 169.561 30.9885ZM 136.796 26.0447L 169.982 31.1007L 170.584 27.1463L 137.398 22.0903L 136.796 26.0447ZM 70.6479 15.4382L 113.685 17.0891L 113.838 13.092L 70.8013 11.4411L 70.6479 15.4382ZM 113.043 16.9572L 136.379 25.9342L 137.815 22.2009L 114.479 13.2239L 113.043 16.9572ZM 1.1327 27.4442L 38.6711 1.64833L 36.4057 -1.64833L -1.1327 24.1475L 1.1327 27.4442ZM 36.7877 1.85375L 69.9739 15.2934L 71.4753 11.5859L 38.2892 -1.85375L 36.7877 1.85375Z",
    id: "ref2718"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    "data-aspect-ratio": "wide",
    "data-slug": "column",
    "data-variant": "d",
    height: 70,
    preserveAspectRatio: "none",
    viewBox: "0 0 272 102",
    width: 105,
    x: 78,
    xmlns: "http://www.w3.org/2000/svg",
    y: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ref1496",
    transform: "translate(18226 6883)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "evenodd",
    id: "ref1493"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -18226 -6883L -17954 -6883L -17954 -6781L -18226 -6781L -18226 -6883Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ref1493)",
    id: "ref1495"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -18226 -6883L -17954 -6883L -17954 -6781L -18226 -6781L -18226 -6883Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ref1494"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    transform: "translate(-18226 -6883)",
    xlinkHref: "#ref1497"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "matrix(1 -4.54158e-18 -2.48922e-17 1 -18220 -6811.37)",
    xlinkHref: "#ref1498"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 -2.47743e-17 -9.23134e-17 1 -18205.9 -6875)",
    xlinkHref: "#ref1499"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "matrix(1 -3.69147e-18 -1.33934e-16 1 -18191.7 -6807.29)",
    xlinkHref: "#ref1500"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9fdee0",
    transform: "matrix(1 -3.69147e-18 -1.33934e-16 1 -18177.6 -6799.32)",
    xlinkHref: "#ref1501"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "matrix(1 -1.60702e-18 -7.03475e-17 1 -18152.2 -6805.43)",
    xlinkHref: "#ref1502"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 -9.70319e-18 -2.35696e-16 1 -18138 -6835.73)",
    xlinkHref: "#ref1503"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "matrix(1 -3.69147e-18 -1.33934e-16 1 -18123.9 -6862.25)",
    xlinkHref: "#ref1504"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9fdee0",
    transform: "matrix(1 -3.69147e-18 -1.33934e-16 1 -18109.8 -6840.75)",
    xlinkHref: "#ref1505"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "matrix(1 -1.60702e-18 -7.03475e-17 1 -18084.3 -6814.67)",
    xlinkHref: "#ref1506"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 3.33321e-19 1.80638e-17 1 -18070.2 -6818.87)",
    xlinkHref: "#ref1507"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "matrix(1 -1.60702e-18 -7.03475e-17 1 -18056.1 -6854.29)",
    xlinkHref: "#ref1508"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9fdee0",
    transform: "matrix(1 -3.69147e-18 -1.33934e-16 1 -18042 -6874.2)",
    xlinkHref: "#ref1509"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "matrix(1 -1.60702e-18 -7.03475e-17 1 -18016.5 -6837.78)",
    xlinkHref: "#ref1510"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 -3.69147e-18 -1.33934e-16 1 -18002.4 -6796.93)",
    xlinkHref: "#ref1511"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "matrix(1 -9.70319e-18 -2.35696e-16 1 -17988.3 -6820.27)",
    xlinkHref: "#ref1512"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9fdee0",
    transform: "matrix(1 3.33321e-19 1.80638e-17 1 -17974.1 -6805.53)",
    xlinkHref: "#ref1513"
  }))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 2C 0 0.895431 0.895431 0 2 0L 270 0C 271.105 0 272 0.895431 272 2L 272 100C 272 101.105 271.105 102 270 102L 2 102C 0.895431 102 0 101.105 0 100L 0 2Z",
    id: "ref1497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 30.3714L 0 30.3714L 0 0Z",
    id: "ref1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 93.9993L 0 93.9993L 0 0Z",
    id: "ref1499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 26.2879L 0 26.2879L 0 0Z",
    id: "ref1500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 18.3219L 0 18.3219L 0 0Z",
    id: "ref1501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 24.4292L 0 24.4292L 0 0Z",
    id: "ref1502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 54.7338L 0 54.7338L 0 0Z",
    id: "ref1503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 81.2536L 0 81.2536L 0 0Z",
    id: "ref1504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 59.7453L 0 59.7453L 0 0Z",
    id: "ref1505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 33.6727L 0 33.6727L 0 0Z",
    id: "ref1506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 37.8657L 0 37.8657L 0 0Z",
    id: "ref1507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 73.2876L 0 73.2876L 0 0Z",
    id: "ref1508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 93.2027L 0 93.2027L 0 0Z",
    id: "ref1509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 56.7814L 0 56.7814L 0 0Z",
    id: "ref1510"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 15.9321L 0 15.9321L 0 0Z",
    id: "ref1511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 39.2655L 0 39.2655L 0 0Z",
    id: "ref1512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 14.1304 0L 14.1304 24.5327L 0 24.5327L 0 0Z",
    id: "ref1513"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    "data-aspect-ratio": "wide",
    "data-slug": "line",
    "data-variant": "e",
    height: 57,
    preserveAspectRatio: "none",
    viewBox: "0 0 272 102",
    width: 105,
    x: 189,
    xmlns: "http://www.w3.org/2000/svg",
    y: 67,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ref2714",
    transform: "translate(17914 9134)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "evenodd",
    id: "ref2711"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17914 -9134L -17642 -9134L -17642 -9032L -17914 -9032L -17914 -9134Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ref2711)",
    id: "ref2713"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17914 -9134L -17642 -9134L -17642 -9032L -17914 -9032L -17914 -9134Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ref2712"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    transform: "translate(-17914 -9134)",
    xlinkHref: "#ref2715"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#9fdee0",
    transform: "translate(-17915.1 -9115)",
    xlinkHref: "#ref2716"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "translate(-17919 -9093)",
    xlinkHref: "#ref2717"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "matrix(-1 -6.33558e-17 2.3672e-16 -1 -17638 -9053)",
    xlinkHref: "#ref2718"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "matrix(1 -5.91089e-17 -1.14255e-16 1 -17919 -9107)",
    xlinkHref: "#ref2718"
  }))))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 2C 0 0.895431 0.895431 0 2 0L 270 0C 271.105 0 272 0.895431 272 2L 272 100C 272 101.105 271.105 102 270 102L 2 102C 0.895431 102 0 101.105 0 100L 0 2Z",
    id: "ref2715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 137.097 27.1372L 136.318 28.9793L 137.429 29.4491L 138.363 28.6855L 137.097 27.1372ZM 70.7246 4.43688L 71.23 2.50179L 70.446 2.29704L 69.7406 2.69567L 70.7246 4.43688ZM 203.469 23.1131L 202.326 24.7542L 203.205 25.3662L 204.201 24.9743L 203.469 23.1131ZM 236.655 10.0604L 236.168 8.12062L 236.043 8.15201L 235.923 8.19916L 236.655 10.0604ZM 170.283 0L 171.426 -1.64118L 170.186 -2.50455L 169.017 -1.54826L 170.283 0ZM 103.911 13.1043L 104.69 11.2622L 104.556 11.2058L 104.416 11.1692L 103.911 13.1043ZM 37.5384 23.1905L 36.5545 21.4492L 36.3628 21.5576L 36.1992 21.705L 37.5384 23.1905ZM 204.201 24.9743L 237.387 11.9216L 235.923 8.19916L 202.737 21.2519L 204.201 24.9743ZM 237.143 12.0001L 274.681 2.57175L 273.707 -1.30775L 236.168 8.12062L 237.143 12.0001ZM 169.14 1.64118L 202.326 24.7542L 204.612 21.4719L 171.426 -1.64118L 169.14 1.64118ZM 138.363 28.6855L 171.549 1.54826L 169.017 -1.54826L 135.831 25.589L 138.363 28.6855ZM 70.2192 6.37197L 103.405 15.0394L 104.416 11.1692L 71.23 2.50179L 70.2192 6.37197ZM 103.132 14.9464L 136.318 28.9793L 137.876 25.2951L 104.69 11.2622L 103.132 14.9464ZM 1.33923 58.52L 38.8777 24.6759L 36.1992 21.705L -1.33923 55.5492L 1.33923 58.52ZM 38.5224 24.9317L 71.7085 6.17809L 69.7406 2.69567L 36.5545 21.4492L 38.5224 24.9317Z",
    id: "ref2716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 140.004 19L 140.004 21L 140.441 21L 140.838 20.8175L 140.004 19ZM 72.224 8.02125L 72.7088 6.08087L 72.2691 5.97103L 71.8249 6.06147L 72.224 8.02125ZM 207.783 15.8822L 207.094 17.7597L 207.427 17.8822L 207.783 17.8822L 207.783 15.8822ZM 243.269 15.8822L 243.269 17.8822L 243.672 17.8822L 244.044 17.7256L 243.269 15.8822ZM 173.893 3.43789L 174.583 1.56046L 173.808 1.27612L 173.059 1.62035L 173.893 3.43789ZM 116.173 19L 115.688 20.9404L 115.927 21L 116.173 21L 116.173 19ZM 38.3343 14.9229L 37.6088 16.7867L 38.157 17.0001L 38.7334 16.8827L 38.3343 14.9229ZM 207.783 17.8822L 243.269 17.8822L 243.269 13.8822L 207.783 13.8822L 207.783 17.8822ZM 244.044 17.7256L 281.776 1.84335L 280.224 -1.84335L 242.493 14.0389L 244.044 17.7256ZM 173.204 5.31531L 207.094 17.7597L 208.472 14.0048L 174.583 1.56046L 173.204 5.31531ZM 140.838 20.8175L 174.728 5.25542L 173.059 1.62035L 139.169 17.1825L 140.838 20.8175ZM 71.7393 9.96162L 115.688 20.9404L 116.658 17.0596L 72.7088 6.08087L 71.7393 9.96162ZM 116.173 21L 140.004 21L 140.004 17L 116.173 17L 116.173 21ZM -0.725517 1.86413L 37.6088 16.7867L 39.0598 13.0592L 0.725517 -1.8634L -0.725517 1.86413ZM 38.7334 16.8827L 72.6232 9.98102L 71.8249 6.06147L 37.9352 12.9632L 38.7334 16.8827Z",
    id: "ref2717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 137.097 24.0675L 136.379 25.9342L 136.581 26.012L 136.796 26.0447L 137.097 24.0675ZM 70.7246 13.4396L 69.9739 15.2934L 70.2982 15.4247L 70.6479 15.4382L 70.7246 13.4396ZM 204.187 42.2536L 203.465 44.1186L 204.636 44.5721L 205.553 43.7144L 204.187 42.2536ZM 235 13.4396L 235.645 11.5466L 234.51 11.1595L 233.634 11.9788L 235 13.4396ZM 170.283 29.1235L 171.005 27.2585L 170.801 27.1793L 170.584 27.1463L 170.283 29.1235ZM 113.761 15.0906L 114.479 13.2239L 114.17 13.1048L 113.838 13.092L 113.761 15.0906ZM 37.5384 0L 38.2892 -1.85375L 37.2922 -2.2575L 36.4057 -1.64833L 37.5384 0ZM 205.553 43.7144L 236.366 14.9004L 233.634 11.9788L 202.821 40.7928L 205.553 43.7144ZM 234.355 15.3326L 280.355 31.0165L 281.645 27.2305L 235.645 11.5466L 234.355 15.3326ZM 169.561 30.9885L 203.465 44.1186L 204.909 40.3885L 171.005 27.2585L 169.561 30.9885ZM 136.796 26.0447L 169.982 31.1007L 170.584 27.1463L 137.398 22.0903L 136.796 26.0447ZM 70.6479 15.4382L 113.685 17.0891L 113.838 13.092L 70.8013 11.4411L 70.6479 15.4382ZM 113.043 16.9572L 136.379 25.9342L 137.815 22.2009L 114.479 13.2239L 113.043 16.9572ZM 1.1327 27.4442L 38.6711 1.64833L 36.4057 -1.64833L -1.1327 24.1475L 1.1327 27.4442ZM 36.7877 1.85375L 69.9739 15.2934L 71.4753 11.5859L 38.2892 -1.85375L 36.7877 1.85375Z",
    id: "ref2718"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    "data-aspect-ratio": "square",
    "data-slug": "column_stacked",
    "data-variant": "c",
    height: 132,
    preserveAspectRatio: "none",
    viewBox: "0 0 136 102",
    width: 154,
    x: 5,
    xmlns: "http://www.w3.org/2000/svg",
    y: 130,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ref2089",
    transform: "translate(17874 11769)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "evenodd",
    id: "ref2086"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17874 -11769L -17738 -11769L -17738 -11667L -17874 -11667L -17874 -11769Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ref2086)",
    id: "ref2088"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17874 -11769L -17738 -11769L -17738 -11667L -17874 -11667L -17874 -11769Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ref2087"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    transform: "translate(-17874 -11769)",
    xlinkHref: "#ref2090"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "translate(-17870 -11701.6)",
    xlinkHref: "#ref2091"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 0 0 -1 -17870 -11701.6)",
    xlinkHref: "#ref2092"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "translate(-17870 -11737.6)",
    xlinkHref: "#ref2093"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "translate(-17825.5 -11733.1)",
    xlinkHref: "#ref2095"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 0 0 -1 -17825.5 -11733.1)",
    xlinkHref: "#ref2096"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "translate(-17825.5 -11751)",
    xlinkHref: "#ref2097"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "translate(-17781.1 -11718.2)",
    xlinkHref: "#ref2099"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 0 0 -1 -17781.1 -11718.2)",
    xlinkHref: "#ref2100"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "translate(-17781.1 -11735.2)",
    xlinkHref: "#ref2101"
  }))))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 2C 0 0.895431 0.895431 0 2 0L 134 0C 135.105 0 136 0.895431 136 2L 136 100C 136 101.105 135.105 102 134 102L 2 102C 0.895431 102 0 101.105 0 100L 0 2Z",
    id: "ref2090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 34.6113L 0 34.6113L 0 0Z",
    id: "ref2091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 22.1513L 0 22.1513L 0 0Z",
    id: "ref2092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 13.8445L 0 13.8445L 0 0Z",
    id: "ref2093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 8.30672L 0 8.30672L 0 0Z",
    id: "ref2094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 66.1109L 0 66.1109L 0 0Z",
    id: "ref2095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 10.8889L 0 10.8889L 0 0Z",
    id: "ref2096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 6.99998L 0 6.99998L 0 0Z",
    id: "ref2097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 6.99998L 0 6.99998L 0 0Z",
    id: "ref2098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 51.1874L 0 51.1874L 0 0Z",
    id: "ref2099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 9.24216L 0 9.24216L 0 0Z",
    id: "ref2100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 7.82029L 0 7.82029L 0 0Z",
    id: "ref2101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 39.0627 0L 39.0627 7.10936L 0 7.10936L 0 0Z",
    id: "ref2102"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    "data-aspect-ratio": "square",
    "data-slug": "column_stacked",
    "data-variant": "a",
    height: 132,
    preserveAspectRatio: "none",
    viewBox: "0 0 136 102",
    width: 130,
    x: 164,
    xmlns: "http://www.w3.org/2000/svg",
    y: 130,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ref1934",
    transform: "translate(18226 11769)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "evenodd",
    id: "ref1931"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -18226 -11769L -18090 -11769L -18090 -11667L -18226 -11667L -18226 -11769Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ref1931)",
    id: "ref1933"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -18226 -11769L -18090 -11769L -18090 -11667L -18226 -11667L -18226 -11769Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ref1932"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    transform: "translate(-18226 -11769)",
    xlinkHref: "#ref1935"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "translate(-18222 -11701.6)",
    xlinkHref: "#ref1936"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 0 0 -1 -18222 -11701.6)",
    xlinkHref: "#ref1937"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "translate(-18222 -11737.6)",
    xlinkHref: "#ref1938"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "translate(-18189 -11693)",
    xlinkHref: "#ref1940"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 0 0 -1 -18189 -11693)",
    xlinkHref: "#ref1941"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "translate(-18189 -11723.8)",
    xlinkHref: "#ref1942"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "translate(-18156 -11733.1)",
    xlinkHref: "#ref1944"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 0 0 -1 -18156 -11733.1)",
    xlinkHref: "#ref1945"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "translate(-18156 -11751)",
    xlinkHref: "#ref1946"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62bad4",
    transform: "translate(-18123 -11718.2)",
    xlinkHref: "#ref1948"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a9c574",
    transform: "matrix(1 0 0 -1 -18123 -11718.2)",
    xlinkHref: "#ref1949"
  })), /*#__PURE__*/React.createElement("g", {
    className: "color3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    transform: "translate(-18123 -11735.2)",
    xlinkHref: "#ref1950"
  }))))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 2C 0 0.895431 0.895431 0 2 0L 134 0C 135.105 0 136 0.895431 136 2L 136 100C 136 101.105 135.105 102 134 102L 2 102C 0.895431 102 0 101.105 0 100L 0 2Z",
    id: "ref1935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 34.6113L 0 34.6113L 0 0Z",
    id: "ref1936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 22.1512L 0 22.1512L 0 0Z",
    id: "ref1937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 13.8445L 0 13.8445L 0 0Z",
    id: "ref1938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 8.30672L 0 8.30672L 0 0Z",
    id: "ref1939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 26.0461L 0 26.0461L 0 0Z",
    id: "ref1940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 18.6998L 0 18.6998L 0 0Z",
    id: "ref1941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 12.0213L 0 12.0213L 0 0Z",
    id: "ref1942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 9.34988L 0 9.34988L 0 0Z",
    id: "ref1943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 66.1109L 0 66.1109L 0 0Z",
    id: "ref1944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 10.8889L 0 10.8889L 0 0Z",
    id: "ref1945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 6.99998L 0 6.99998L 0 0Z",
    id: "ref1946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 6.99998L 0 6.99998L 0 0Z",
    id: "ref1947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 51.1873L 0 51.1873L 0 0Z",
    id: "ref1948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 9.24216L 0 9.24216L 0 0Z",
    id: "ref1949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 7.82029L 0 7.82029L 0 0Z",
    id: "ref1950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0L 28.9883 0L 28.9883 7.10935L 0 7.10935L 0 0Z",
    id: "ref1951"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsPlaceholder);
export default __webpack_public_path__ + "static/media/metrics-placeholder.e23847adaa26bd8449c126e63b9b1f6e.svg";
export { ForwardRef as ReactComponent };